module.exports = __webpack_public_path__ + "img/return.6310db0e.svg";